import { Navigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { getTenantIdentifier } from '../../../utils/getTenantIdentifier';
import { displayTenantSwitcherAfterLoginState } from '../../application/atoms';

export const TenantRootPage = () => {
  const displayTenantSwitcherAfterLogin = useAtomValue(displayTenantSwitcherAfterLoginState);

  if (displayTenantSwitcherAfterLogin) {
    return <Navigate to={`/${getTenantIdentifier()}/switch`} replace />;

  }

  return <Navigate to={`/${getTenantIdentifier()}/projects`} replace />;
};